const utils = require('../../lib/utils')

module.exports = {
    events: {
        click: function(event){
            const self      = event.data.component
            const target    = event.originalEvent ? event.originalEvent.target : event.target
            const $target	= $(target)
            const $button  	= $target.closest('.base_form_elements_buttons_default')

            if($button.length > 0 && self.$.find($button).length > 0){
                event.preventDefault()
                event.stopImmediatePropagation()
                utils.performButtonAction(event, 'base_form_form', {
                    registerSecret: self.config.registerSecret
                })
            } else {
                self.parent(accordionElement => {
                    accordionElement.toggle()
                })
            }
        }
    }
}